import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles(() =>
  createStyles({
    headerContainer: {
      marginBottom: 8,
    },
    actionsContainer: {
      marginTop: 16,
    },
  })
);
